import { forwardRef, memo } from "react";
import classNames from "classnames";
import { default as InputNumber, InputNumberProps } from "rc-input-number";
import { InputContainer, InputContainerProps } from "../InputContainer";

import styles from "./style.module.scss";

export type NumberFieldProps = Omit<InputContainerProps<InputNumberProps<number>>, "inputComponent">

export const NumberField = memo(forwardRef<HTMLInputElement, NumberFieldProps>((
  {
    className,
    ...props
  }, ref) => {

  return <InputContainer
    {...props}
    rootContainerProps={{
      ...props.rootContainerProps,
      className: classNames(props.rootContainerProps?.className, styles.root),
    }}
    prefixCls="mimic-number-field"
    ref={ref}
    inputComponent={InputNumber}
  />;
}));



